import { Badge } from "@/components/ui/badge";
import { Clock3 } from "lucide-react";

export default function ComingSoon({ label = "Enterprise only", variant = "default" }) {
  const base = "font-mono text-[10px] tracking-[0.2em] uppercase rounded-sm";
  if (variant === "ghost") {
    return (
      <span
        data-testid="coming-soon-badge"
        className={`${base} px-1.5 py-0.5 border border-white/15 text-zinc-400`}
      >
        <Clock3 className="inline h-3 w-3 mr-1 -mt-0.5" strokeWidth={1.5} />
        {label}
      </span>
    );
  }
  return (
    <Badge
      data-testid="coming-soon-badge"
      variant="outline"
      className={`${base} border-amber-500/30 text-amber-300 bg-amber-500/5`}
    >
      <Clock3 className="inline h-3 w-3 mr-1 -mt-0.5" strokeWidth={1.5} />
      {label}
    </Badge>
  );
}
